import { $dialogQueue, type DialogQueueItem } from './stores'

type DialogOpenOptions = {
  onDuplicate?: 'replace' | 'ignore'
}

export const openDialog = (
  id: DialogQueueItem['id'],
  payload?: DialogQueueItem['payload'],
  options: DialogOpenOptions = {},
) => {
  const queue = $dialogQueue.get()
  const item: DialogQueueItem = { id, payload }
  if (options.onDuplicate === 'replace') {
    $dialogQueue.set([...queue.filter((i) => i.id !== id), item])
  } else if (options.onDuplicate === 'ignore') {
    if (!queue.some((i) => i.id === id)) {
      $dialogQueue.set([...queue, item])
    }
  } else {
    $dialogQueue.set([...queue, item])
  }
}

export const closeDialog = () => {
  const queue = $dialogQueue.get()
  const newQueue = queue.slice(0, queue.length - 1)
  $dialogQueue.set(newQueue)
}
